import store from '@/store'
import { NativeEventSource, EventSourcePolyfill } from 'event-source-polyfill'

const EventSource = NativeEventSource || EventSourcePolyfill

const entities = [
  { id: 'event', topic: encodeURIComponent(`${process.env.VUE_APP_BASE_API}event/{id}`) },
  { id: 'action', topic: encodeURIComponent(`${process.env.VUE_APP_BASE_API}event/{id}/action/{id}`) },
  { id: 'information', topic: encodeURIComponent(`${process.env.VUE_APP_BASE_API}event/{id}/information/{id}`) }
]

export default function configureEventSources () {
  entities.forEach(entity => {
    const eventSourceUrl = new EventSource(`${process.env.VUE_APP_SSE_URI}${entity.topic}`)
    eventSourceUrl.addEventListener('message', event => {
      const parsed = JSON.parse(event.data)
      let payload = {}
      const { id, ...itemWithoutId } = parsed.entity

      switch (parsed.action) {
        case 'create':
          payload = parsed.entity
          break
        case 'update':
          payload = { id, item: itemWithoutId }
          break
        case 'delete':
          payload = id
      }

      if (parsed.action === 'create') {
        store.dispatch(`map/findAll${entity.id.charAt(0).toUpperCase() + entity.id.slice(1)}s`, true)
          .then(() => {
            store.dispatch('map/setFromSse', false)
          })

        if (entity.id === 'event') {
          store.dispatch('grid/findAllEvents')
        }
      }

      if (['update', 'delete'].indexOf(parsed.action) > -1) {
        store.commit(`${entity.id}/${parsed.action}`, payload)
        store.dispatch(`map/findAll${entity.id.charAt(0).toUpperCase() + entity.id.slice(1)}s`, true)
          .then(() => {
            store.dispatch('map/setFromSse', false)
          })

        if (entity.id === 'event') {
          store.dispatch('grid/findAllEvents')
        }
      }
    })
  })
}
